import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.error("ERREUR CRITIQUE : Les variables d'environnement Supabase sont manquantes.");
}

// On utilise un fallback vide pour ne pas faire crasher l'app au démarrage si les vars manquent
// Cela permettra au moins d'afficher l'interface (même si les données ne chargeront pas)
export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co', 
  supabaseAnonKey || 'placeholder'
)
